<template>
  <div id="contenedor-contrato-firmas-main">
    <tool-bar
      v-if="!$apollo.loading"
      class="my-3"
      v-on:nuevaFirma="registrarNuevaFirma"
    >
    </tool-bar>
    <!-- Loader -->
    <v-skeleton-loader
      v-if="$apollo.loading"
      type="table-heading, table-thead, table-tbody"
    >
    </v-skeleton-loader>
    <listado
      v-if="!$apollo.loading"
      :listadoFirmas="getContratoFirmas">
    </listado>
    <!-- Ventana Registrar Nueva Firma -->
    <v-dialog
      v-model="mostrarRegistrarNuevaFirma"
      width="600"
      persistent>
      <nueva-firma
        v-if="contrato && mostrarRegistrarNuevaFirma"
        :idContrato="contrato.id"
        v-on:cerrar="cerrarVentana"
      >
      </nueva-firma>
    </v-dialog>
    <!-- Ventana Eliminar Firma -->
    <v-dialog
      v-if="estaFirma"
      v-model="mostrarEliminarFirma"
      :width="!$vuetify.breakpoint.mobile ? '450' : '90%'">
        <eliminar-firma
          :firma="estaFirma"
          v-on:cerrar="cerrarVentana"
        />
    </v-dialog>
  </div>
</template>

<script>
import CONTRATO from '@/graphql/querys/administracion/contratos/contrato.gql';
import FIRMAS_POR_CONTRATO from '@/graphql/querys/administracion/contratos/firmas/firmasPorContrato.gql';
import ToolBar from './ToolBar.vue';
import NuevaFirma from '@/components/administracion/contratos/contrato/firmas/Nueva.vue';
import EliminarFirma from '@/components/administracion/contratos/contrato/firmas/Eliminar.vue';
import Listado from './listado/Main.vue';
import eventBus from '@/helpers/eventBus';

export default {
  name: 'ContratoFirmasMain',
  components: {
    ToolBar,
    Listado,
    NuevaFirma,
    EliminarFirma,
  },
  data() {
    return {
      mostrarRegistrarNuevaFirma: false,
      mostrarEliminarFirma: false,
      estaFirma: null,
    };
  },
  methods: {
    registrarNuevaFirma() {
      this.mostrarRegistrarNuevaFirma = true;
    },
    cerrarVentana() {
      this.mostrarRegistrarNuevaFirma = false;
      this.mostrarEliminarFirma = false;
      this.estaFirma = null;
    },
  },
  apollo: {
    contrato: {
      query: CONTRATO,
      variables() {
        return {
          id: this.$route.params.idContrato,
        };
      },
    },
    firmasPorContrato: {
      query: FIRMAS_POR_CONTRATO,
      variables() {
        return {
          idContrato: this.$route.params.idContrato,
        };
      },
    },
  },
  computed: {
    getContratoFirmas() {
      if (!this.firmasPorContrato) return [];
      return this.firmasPorContrato
        .slice()
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
    },
  },
  mounted() {
    eventBus.$on('eliminar-firma-contrato', (firmaContrato) => {
      this.estaFirma = firmaContrato;
      this.mostrarEliminarFirma = true;
    });
  },
};
</script>

<style lang="scss">
</style>
